<div class="msc-blank">
    <div class="msc-blank-icon">⚠</div>
    <div class="msc-blank-title">
      {{'Unfortunately, there is no data' | translate}}
    </div>
    <!-- <div class="msc-blank-desc">
      This information needs to be added by your manager
    </div> -->
  </div>